import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { DocumentsByProcessType, DocumentsByUser, Statistics, TimelineData } from '../../common/types/types';
import { useEffect, useState } from 'react';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface Props {
  statistics: Statistics | TimelineData | DocumentsByUser | DocumentsByProcessType | undefined;
  title: string;
  //   graphData: string;
}

export const BarGraph = ({ statistics, title }: Props) => {
  const [data, setData] = useState({
    labels: [''],
    datasets: [
      {
        label: 'Number of documents',
        data: [0],
        backgroundColor: ['#F07714'],
        borderColor: ['#F07714'],
        borderWidth: 1,
        borderRadius: 5,
      },
    ],
  });

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: title,
        font: {
          size: 24,
          family: 'ManropeRegular',
        },
      },
    },
  };

  useEffect(() => {
    setData({
      labels: statistics ? Object.keys(statistics) : [''],
      datasets: [
        {
          label: 'Number of documents',
          data: statistics ? Object.values(statistics) : [0],
          backgroundColor: ['#F07714'],
          borderColor: ['#F07714'],
          borderWidth: 1,
          borderRadius: 5,
        },
      ],
    });
  }, [statistics]);

  return (
    <>
      <div className='bar-graph'>
        <Bar options={options} data={data} />
      </div>

      {/* <div className='bar-graph' style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
      <div style={{ flex: 1 }}>
        <Bar options={options} data={data} />
      </div>
      <div style={{ flex: 0.3 }}>
        <h3>Data Values</h3>
        <ul>
          {data.labels.map((label, index) => (
            <li key={index}>
              {label}: {data.datasets[0].data[index] || 0}
            </li>
          ))}
        </ul>
      </div>
    </div> */}
    </>
  );
};
